import React, { useState } from 'react';
import { Box } from '@mui/material';

import { Modal, ModalContents, ModalTitle, ModalButton } from 'components/Modal/Modal';
import { BackButton } from 'retired/BackButtonLayout/BackButton';
import { primaryBlue } from 'utils/color-styles';
import { Employee } from 'utils/useFetchEmployees';
import { UserMultiSelect } from 'containers/CommunityPage/EmployeeSearch/UserMultiSelect';
import { MemberDisplay } from 'containers/CommunityPage/AddMembersModal/MemberDisplay';

import { AddMembersReviewModal } from './AddMembersReviewModal';
import { MembersUpload } from './MembersUpload';

interface Props {
  communityId: string;
  onClickClose: () => void;
}

export const AddMembersModal = ({ communityId, onClickClose }: Props) => {
  const [reviewToggled, setReviewToggled] = useState(false);
  const goBack = () => setReviewToggled(false);
  const [chosenMembers, setChosenMembers] = useState<Employee[]>([]);
  const [invalidEmails, setInvalidEmails] = useState<string[]>([]);
  const removeMember = (memberId: string) => {
    setChosenMembers(chosenMembers.filter((m) => m.id !== memberId));
  };

  if (reviewToggled) {
    return (
      <AddMembersReviewModal
        communityId={communityId}
        goBack={goBack}
        onClickClose={onClickClose}
        chosenMembers={chosenMembers}
        removeMember={removeMember}
        invalidEmails={invalidEmails}
      />
    );
  }

  return (
    <Modal open fullWidth onClose={onClickClose} style={{ minHeight: 500 }}>
      <ModalContents
        onClickClose={onClickClose}
        body={
          <div>
            <Box display="flex" alignItems="center" mb={3}>
              <BackButton onClick={onClickClose} />
              <ModalTitle style={{ marginBottom: 0, marginLeft: 12 }}>Add members</ModalTitle>
            </Box>
            <MembersUpload
              onChange={(users, _invalidEmails) => {
                setChosenMembers(users);
                setInvalidEmails(_invalidEmails);
                setReviewToggled(true);
              }}
            />
            <UserMultiSelect
              selectedUsers={chosenMembers}
              setSelectedUsers={setChosenMembers}
              label="Find employees"
              helperText="Search by employee name"
              renderEmployee={(props) => (
                <MemberDisplay {...props} key={props.user.id} communityId={communityId} />
              )}
            />
          </div>
        }
        actions={
          <>
            <ModalButton style={{ color: primaryBlue }} variant="outlined" onClick={onClickClose}>
              Cancel
            </ModalButton>
            &nbsp;
            <ModalButton
              disabled={chosenMembers.length === 0}
              onClick={() => {
                setReviewToggled(true);
              }}
            >
              Review
            </ModalButton>
          </>
        }
      />
    </Modal>
  );
};
